import _get from 'lodash/get'
import _set from 'lodash/set'

export default {
  methods: {
    safeGet: _get,
    safeSet: _set,
  },
}
